(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/themes-constants.js') >= 0) return;  svs.modules.push('/components/themes/themes-constants.js'); 
(function(svs) {
  svs = svs || {};
  svs.themes = svs.themes || {};

  svs.themes.constants = {
    PERIOD1: 5,
    PERIOD2: 6,
    PERIOD3: 7,
    EXTRA_TIME: 3,
    PENALTIES: 4,
    PENALTIES_RESULT: 4,
    CURRENT_RESULT: 9,
    ODDS_INFO_CURRENT: 17,

    eventTypes: {
      NOTSET: 0,
      GOALKEEPER_ENTRY: 1,
      SHOT: 2,
      PENALTY_SHOT: 3,
      GOAL: 4,
      PENALTY: 5,
      TIMEOUT: 6,
      SUBSTITUTION: 7,
      INJURY: 8,
      MATCH_STARTED: 9,
      MATCH_ENDED: 10,
      MATCH_INTERRUPTED: 11,
      MATCH_STARTDELAYED: 12,
      MATCH_CANCELED: 13,
      MATCH_PAUSED: 14,
      CORNER_KICK: 15,
      FREE_KICK: 16,
      OFFSIDE: 17,
      CARD: 18,
      ASSIST: 19,
      RESULT: 20,
      PENALTY_SHOT_SCORES: 21,
      PENALTY_SHOT_MISSES: 22,
      MATCH_POSTPONED: 23,
      MATCH_ABANDONED: 24,
      SHOT_OFFTARGET: 25,
      RECOVERED_FROM_INJURY: 26,
      EXTRA_TIME: 27,
      PENALTY_SHOT_SAVES: 28
    }
  };
})(svs);

 })(window);